/* ===========================
IMPORTS
=========================== */
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Snackbar } from '@mui/material';
// IMPORT - STYLING
// IMPORT - COMPONENTS
// IMPORT - ELEMENTS
import Loader from '../Elements/Loader';
// IMPORT - Helpers
import Helpers from '../../Helpers';

/* ===========================
CLASS
=========================== */
class CanvasUpload extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
  * Main constructor of Component
  */
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: false,
      submitted: false,
      success: null,
      errors: null,
      showErrorMessage: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.request = this.request.bind(this);
  }

  /**
  * componentDidMount
  */
  componentDidMount() {
    // Show the component
    this.props.updateLoadingApp(false);
    this.props.updateLoadingContent(false);
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   */
  request() {
    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/players`,
      'post',
      JSON.stringify({
        players: this.state.data,
      }),
      // callback
      (response) => {
        this.setState({
          success: `Successfully uploaded ${response.player_ids.length} entries.`,
          data: [],
          submitted: false,
        });
      },
      // failback
      (error) => {
        this.setState({
          errors: error?.message || 'There was an error',
          submitted: false,
          showErrorMessage: true,
        });
        setTimeout(() => {
          this.setState({
            showErrorMessage: false,
          });
        }, [5000]);
      },
    );
  }

  /**
   * @param {Event} event
   */
  handleChange(event) {
    // reset errors
    this.setState({
      data: [],
      loading: true,
      submitted: false,
      success: false,
      errors: null,
      showErrorMessage: false,
    });

    // validate file name
    if (event.target.value.match(/.+(\.csv)$/)) {
      if (typeof (FileReader) !== 'undefined') {
        const reader = new FileReader();

        reader.onload = (e) => {
          const rows = e.target.result.split('\n');
          const keys = rows[0].split(',');
          let data = [];
          for (let i = 0; i < rows.length; i += 1) {
            const csvRow = rows[i].split(',');
            const rowData = [];
            for (let c = 0; c < keys.length; c += 1) {
              // account for undefined values with emptry string
              rowData[c] = (csvRow[c] !== undefined && csvRow[c] !== null) ? csvRow[c] : '';
            }
            data.push(rowData);
          }

          // remove top csv headers
          data = data.slice(1);

          // filter out blanks
          data = data.filter((items) => {
            const left = items.filter((item) => (item.length > 0
              && item !== null && item !== undefined));
            return (left.length > 0);
          });

          // assign to new object
          const objData = [];
          for (let r = 0; r < data.length; r += 1) {
            const rowData = {};
            for (let c = 0; c < keys.length; c += 1) {
              rowData[keys[c]] = data[r][c];
            }
            objData.push(rowData);
          }

          // update state
          this.setState({
            data: objData,
            loading: false,
            submitted: false,
          });
        };

        reader.readAsText(event.target.files[0]);
      }
    } else {
      this.setState({
        loading: false,
        submitted: false,
        errors: 'File must be a .csv',
        showErrorMessage: true,
      });
    }
  }

  /**
   * @param {Event} event
   */
  handleSubmit(event) {
    this.setState({
      success: null,
      errors: null,
      submitted: true,
    }, () => {
      this.request();
    });

    event.preventDefault();
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      <div id="Canvas-Upload" className="container-fluid">
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          open={this.state.showErrorMessage}
          message={this.state.errors || ''}
          className="error-snackbar"
        />
        <div className="row">
          <div className="col col-12">
            <div className="page-header">
              <h1>
                Canvases
                <span>Upload</span>
              </h1>
            </div>

            <div className="content">
              <div className="table-data">
                <form onSubmit={this.handleSubmit}>
                  <label htmlFor="file"><strong>Please make sure to have the key values at the top of the csv file.</strong></label>
                  <div className="custom-file">
                    <input onChange={this.handleChange} type="file" className="custom-file-input" name="file" id="file-upload" disabled={(this.state.loading || this.state.submitted)} />
                    <label className="custom-file-label" htmlFor="customFile">Choose file</label>
                  </div>

                  {(this.state.data && this.state.data.length > 0)
                    ? (
                      <div>
                        <div className="form-group float-left">
                          <button type="submit" className="btn btn-rounded btn-primary" disabled={(this.state.loading || this.state.submitted)}>
                            <i className="fa fa-upload" />
&nbsp;
                            {(this.state.submitted) ? 'Loading...' : 'Upload'}
                          </button>
                        </div>
                        <span className="table-data-results">
                          {(this.state.data.length > 0) ? '1' : '0'}
                          -
                          {this.state.data.length}
                          {' '}
                          of
                          {' '}
                          {this.state.data.length}
                        </span>
                      </div>
                    )
                    : null}
                </form>
              </div>

              {(this.state.loading) ? (<Loader />) : ''}

              {(this.state.success) ? (
                <div className="alert alert-success">
                  <strong>Success</strong>
                  {' '}
                  -
                  {' '}
                  {this.state.success}
                </div>
              ) : ''}

              {(this.state.data && this.state.data.length > 0)
                ? (
                  <div className="Tables-Data">
                    <div className="Tables">
                      <div className="table-responsive">
                        <table className="table table-bordered table-hover">
                          <thead>
                            <tr>
                              {(Object.keys(this.state.data[0]).map((item) => (
                                <th key={item}>{item}</th>
                              )))}
                            </tr>
                          </thead>
                          <tbody>
                            {(this.state.data.map((item, key) => (
                              // eslint-disable-next-line react/no-array-index-key
                              <tr key={key}>
                                {(Object.keys(item).map((value) => (
                                  <td key={value}>{item[value]}</td>
                                )))}
                              </tr>
                            )))}
                          </tbody>

                        </table>
                      </div>
                    </div>
                  </div>
                )
                : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
CanvasUpload.propTypes = {
  updateLoadingApp: PropTypes.func,
  updateLoadingContent: PropTypes.func,
};

/* ===========================
EXPORT
=========================== */
export default withRouter(CanvasUpload);
